'use client';

import { QueryClientProvider } from '@tanstack/react-query';
import { type ReactNode, useState } from 'react';

import { createQueryClient } from '~/lib/query.ts';

interface ProvidersProps {
  readonly children: ReactNode;
}

/**
 * Client-side provider tree.
 *
 * Kept deliberately thin - heavier providers (Sentry, OTel, PostHog,
 * Auth) are wired up in their own lib modules and initialized at
 * instrumentation or middleware level, not inside React.
 */
export function Providers({ children }: ProvidersProps) {
  const [queryClient] = useState(() => createQueryClient());

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
